import ImageWithFallback from 'gcs-common/design-system/ui/image-with-fallback';
import avatarPlaceHolder from 'gcs-common/img/user.svg';

export enum ProfileImageSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
const ProfileImage = ({
  imageUrl,
  size,
  isRounded,
}: {
  imageUrl: string | undefined;
  size: ProfileImageSize;
  isRounded: boolean;
}) => {
  let sizeClass: string;
  switch (size) {
    case ProfileImageSize.SMALL:
      sizeClass = 'h-12 w-12';
      break;
    case ProfileImageSize.MEDIUM:
      sizeClass = 'h-[68px] w-[68px]';
      break;
    case ProfileImageSize.LARGE:
      sizeClass = 'h-24 w-24';
      break;
    default:
      sizeClass = 'h-0 w-0';
  }

  const fallbackImage = (
    <div className="h-full w-full">
      <img src={avatarPlaceHolder} className="h-full w-full object-cover" alt="Bild" />
    </div>
  );
  return (
    <div
      className={`${sizeClass} flex-col items-center justify-center overflow-hidden ${isRounded ? 'rounded-full' : ''}`}
    >
      <ImageWithFallback src={imageUrl} fallback={fallbackImage} alt="Bild" />
    </div>
  );
};

export default ProfileImage;
